<template>
  <v-container class="landing" style="color: black">
    <v-row justify="center">
      <v-col cols="8" align="middle">
        <h2 class="pb-3 fs-xl text-center text--primary">
          IMMUNITÄTSBESTIMMUNG
        </h2>
        <h5 class="pb-3 text-center px-5 text--primary">
          Medizinisch gesehen gilt: Wer eine Abwehrreaktion gegen Covid-19 hat, ist immun. Helfen Sie uns,
          herauszufinden, wie viele Menschen immun sind, die aktuell noch nicht als genesen erfasst werden. Sie können
          hierbei, sofern eine Immunität vorliegt, eine Bescheinigung erhalten.
        </h5>
        <!--<a-button type="primary">
          Sie wollen wissen, auf welche Sozialleistung Sie Anspruch haben?
          Klicken Sie hier</a-button
        > -->
        <v-row>
          <v-text-field
              v-if="!sent"
              placeholder="Ihre Email-Adresse"
              :rules="[rules.required, rules.email]"
              v-model="mail"></v-text-field>
          <v-btn color="primary" :disabled="!mail || mail.length < 1 || sent || !valid" v-if="!sent" @click="send()">
            ABSENDEN
          </v-btn>
        </v-row>
        <v-btn v-if="sent" color="success" style="margin-top: 50px" class="text-center">
          GESENDET
        </v-btn>
        <div></div>
        <v-btn color="primary" style="margin-top: 50px" class="text-center">
          <router-link to="/form" style="color: white">ZUM FRAGEBOGEN</router-link>
        </v-btn>
        <div></div>
        <v-btn color="primary" style="margin-top: 50px; max-width: 80%">
          <router-link to="/unsubscribe" style="color: white">EIGENE DATEN EINSEHEN</router-link>
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col align="middle" cols="8">
        <v-col style="margin-top: 70px">
          <h3 class="text-center text--primary">!!! Wer Antikörper hat, hat weniger schwere Krankheitsverläufe! !!!</h3>
        </v-col>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-btn
          color="primary"
          :href="$store.state.url + 'Download.pdf'"
          target="_blank"
      >Formular Immunitätserhebung</v-btn>
    </v-row>
    <v-row justify="center">
      <v-col align="middle" cols="8">
        <v-col style="margin-top: 70px">
          <h3 class="text-center text--primary">Die Immunitätsbescheinigung ermöglicht die Teilnahme am
            gesellschaftlichen Leben</h3>
          <h6 class="center text--primary">Zusendung eines Teilnehmers:</h6>
          <h5 style="font-style: italic" class="text--primary">Guten Tag Dr. Elke Austenat, Ich bin sehr zufrieden mit
            der Immunitätsbescheinigung, vor allem da ich bisher davon profitieren kann. Und deshalb möchte ich Sie um
            eine Immunitätsbescheinigung für meinen Bruder bitten.</h5>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '../plugins/axios'

export default {
  props: {},
  computed: {
    returnMailCorrect() {
      let response = () => this.rules.email()
      return response
    }
  },
  data() {
    return {
      valid: false,
      mail: null,
      sent: false,
      rules: {
        required: (value) => {
          if(value) {
            this.valid = true
            return true
          } else {
            this.valid = false
            return 'Feld darf nicht leer sein'
          }
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if(pattern.test(value)) {
            this.valid = true
            return true
          } else {
            this.valid = false
            return 'Email ist nicht korrekt'

          }
        },
      },
    }
  },
  methods: {
    send() {
      let self = this

      const payload2 = {}
      payload2.email = this.mail
      payload2.action = 'register'
      axios.post(self.$store.state.url + 'api/edit.php', payload2).then((response) => console.log(reponse))

      this.sent = true

      /*const payload = {}
      payload.path = 'users/send-activition-mail'
      payload.email = this.mail
      payload.lang = 'de_DE'
      this.$store.dispatch('sendPostRequest', payload) */

      this.mail = null
    }
  }
};
</script>
<style>
.landing {
  background-image: url('https://evidenz.carolinholat.de/adult-4402808_1920.jpg');
  min-width: 100%;
  min-height: 1570px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: -100px;
}
</style>
